import { createContext, useContext } from 'react';

export interface UserContextType {
  userId: string;
  userName: string;
  responsibilityId: string;
  sessionId: string;
}

export const UserContext = createContext<UserContextType>({
  userId: '',
  userName: '',
  responsibilityId: '',
  sessionId: ''
});

export const useUserContext = () => useContext(UserContext);